import {
  AddCircle,
  SelectAll,
  ViewComfyAlt,
  ViewCompact,
} from "@mui/icons-material";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import {
  Badge,
  Box,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  useTheme,
} from "@mui/material";

import I18n from "i18n";
import CreateEventButton from "../CreateEventButton";
import ActivateEventsButton from "./ActivateEventsButton";
import CancelEventsButton from "./CancelEventsButton";
import DeleteEventsButton from "./DeleteEventsButton";
import EditEventsButton from "./EditEventsButton";
import { useEventEditorContext } from "./EventEditorContext";
import ShiftGroupsButton from "./ShiftGroupsButton";

export default function EditorToolbar() {
  const theme = useTheme();
  const {
    editMode,
    groupEditMode,
    selectedEvents,
    selectedEventGroups,
    resetSelection,
    selectSameEvents,
    selectSameGroups,
    selectEvent,
    viewMode,
    setViewMode,
    cal,
    groupActionsEnabled,
    isGroupMode,
    selectionCount,
  } = useEventEditorContext();

  if (!editMode) return null;
  return (
    <Box
      sx={{
        mt: 1,
        //p: 0.5,
        //borderRadius: 1,
        bgcolor: theme.palette.mode === "dark" ? "grey.800" : "grey.100",
        display: "flex",
        alignItems: "center",
        overflowX: "auto",
        gap: 0.5,
      }}
    >
      {/* View Mode Toggle */}
      <ToggleButtonGroup
        exclusive
        value={viewMode}
        onChange={(_, v) => v && setViewMode(v)}
        size="small"
        sx={{ "& button": { borderRadius: 0 } }}
      >
        <ToggleButton value="normal">
          <Tooltip title={I18n.t("EventEditor.viewModes.normal")}>
            <ViewComfyAlt />
          </Tooltip>
        </ToggleButton>
        <ToggleButton value="minimal">
          <Tooltip title={I18n.t("EventEditor.viewModes.minimal")}>
            <ViewCompact />
          </Tooltip>
        </ToggleButton>
      </ToggleButtonGroup>
      <CreateEventButton
        title={I18n.t("EventEditor.createEvent")}
        afterSave={() => cal?.current?.refresh()}
      >
        <IconButton
          size="small"
          //disabled={!groupActionsEnabled}
          color="info"
        >
          <AddCircle />
        </IconButton>
      </CreateEventButton>

      {editMode === "groupEdit" && (
        <>
          <EditEventsButton />
          {groupEditMode === "group" && <ShiftGroupsButton />}
          <ActivateEventsButton />
          <CancelEventsButton />
          <DeleteEventsButton />
          <Box
            sx={{
              height: 24,
              width: "1px",
              bgcolor: "divider",
              mx: 0.5,
            }}
          />
          {/* Select Similar */}
          <Tooltip
            title={
              isGroupMode
                ? I18n.t("EventEditor.selectSameGroups")
                : I18n.t("EventEditor.selectSameEvents")
            }
          >
            <span>
              <IconButton
                size="small"
                onClick={isGroupMode ? selectSameGroups : selectSameEvents}
                disabled={!groupActionsEnabled}
                color="info"
              >
                <SelectAll />
              </IconButton>
            </span>
          </Tooltip>
          {/* Clear Selection */}
          <Tooltip title={I18n.t("EventEditor.clearSelection")}>
            <span>
              <IconButton
                size="small"
                onClick={resetSelection}
                disabled={!groupActionsEnabled}
                color="info"
              >
                <CancelPresentationIcon />
              </IconButton>
            </span>
          </Tooltip>
        </>
      )}
      {/* Selection Count */}
      {selectionCount > 0 && (
        <Box
          sx={{
            ml: "auto",
            px: 1,
            display: "flex",
            alignItems: "center",
            gap: 2,
            color: "text.secondary",
            pr: 2,
          }}
        >
          {/*<Typography variant="caption">
            {isGroupMode
              ? I18n.t("EventEditor.selectedGroups", {
                  count: selectionCount,
                })
              : I18n.t("EventEditor.selectedEvents", {
                  count: selectionCount,
                })}
          </Typography>*/}
          <Badge
            badgeContent={selectionCount}
            color="secondary"
            //anchorOrigin={{ vertical: "", horizontal: "right" }}
          />
        </Box>
      )}
      {(selectionCount === 0 || editMode !== "groupEdit") &&
        I18n.t(`EventEditor.editModes.${editMode}.description`)}
    </Box>
  );
}
